import React from 'react'

export const Pagination = ({ gotoPage, previousPage, nextPage, canPreviousPage, canNextPage, pageIndex, pageTotal, pageCount }) => {
  return (
    <div className="pagination-container">
      <div className="pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {'<'}
        </button>{' '}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
      </div>
      <div className="pagination">
        Page{' '}
        <strong>
          {pageIndex + 1} of {pageTotal}
        </strong>{' '}
      </div>
    </div>
  )
}